import * as React from 'react';
import { Table, Card, Icon, Button, Row, Col, Modal, Input, DatePicker } from 'antd';
import strings from '../eyeguide-localization/employee/strings.employee';
import Service from '../service/apolloclient.service';
import '../css/TestFilter.scss';
import '../css/CustomerList.scss';
import Comparator from './common/comparer';
import moment from 'moment';
import { CustomSorter } from './Sorter';

const { RangePicker } = DatePicker;

interface ActivityTableProps {
    match: any;
}

interface ActivityTableState {
    tableData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    emptyText: string;
    filterObj: any;
    holdFilter: any;
    filterModalVisible: boolean;
}

const actions = {
    testRecord      : 104,
    baselineRecord  : 103,
    
    orgAdd          : 13,
    orgUpload       : 17,
    customerAdd     : 31,

    login           : 19,
    
    syncComplete    : 107,
    syncFail        : 108        
};

const headers = {
    tests: ['customer', 'organization', 'profile', 'testtype', 'datetime'],
    logins: ['customer', 'username', 'datetime'],
    syncs: ['customer', 'username', 'status', 'datetime'],
    orgs: ['customer', 'organization', 'datetime']
};

const titles = {
    tests: ['Customer', 'Organization', 'Profile', 'Test Type', 'Recorded At'],
    logins: ['Customer', 'User', 'Login Time'],
    syncs: ['Customer', 'User', 'Status', 'Sync Time'],
    orgs: ['Customer', 'Organization', 'Created At']
};

const filters = ['Customer', 'Organization', 'Username', 'Profile Name', 'Date Range'];
let dataHolder = [];
let dateRange: any = [];

export default class ActivityTable extends React.Component<ActivityTableProps, ActivityTableState> {
    inputEl: any;
    listId: string;
    title: string;
    constructor(props: any) {
        super(props);
        this.state = {
            tableData: [],
            columns: [],
            pagination: {},
            loading: true,
            emptyText: '',
            filterObj: {
                customer: '',
                organization: '',
                username: '',
                profile: '',
                daterange: ['', '']
            },
            holdFilter: {
                customer: '',
                organization: '',
                username: '',
                profile: '',
                daterange: ['', '']
            },
            filterModalVisible: false
        };
        const { id, date1, date2 } = this.props.match.params;
        this.title = id === 'tests' ? 'Tests' : id === 'orgs' ? 'Organizations' :
            id === 'logins' ? 'Logins' : 'Syncs';
        this.listId = id;
        dateRange = [date1, date2];
    }

    getActions() {
        return this.listId === 'logins' ? [actions.login]
            : this.listId === 'syncs' ? [actions.syncComplete, actions.syncFail]
            : [];
    }

    componentDidMount() {
        let ser = new Service();
        let filter = {
            username: '',
            dateRange,
            actions: this.getActions(),
            rosterid: '-1',
            dateOrder: 'desc'
        };
        let service: any;
        const { count } = this.props.match.params;
        switch (this.listId) {
            case 'tests':   service = () => ser.getTestRecords(count, filter);
                            break;
            case 'orgs' :   service = () => ser.getCreatedOrgs(count, filter);
                            break;
            default :
                let today = new Date();
                let lastDate = today.toISOString().split('T')[0] + ' 23:59:59';
                service = () => ser.getActivityFeed(count, lastDate, filter);
        }
        service().then((res: any) => {
            const tableData: any = this.buildData(res);
            dataHolder = tableData.slice();
            const pagination = {
                total: res.length,
                pageSize: 20,
                pagination: ['20', '50', '75', '100'],
                showSizeChanger: true,
                showTotal: (total: any) => {
                    return 'Total ' + total + ' ' + this.title;
                }
            };
            this.setState({
                loading: false,
                // holdFilter,
                // filterObj,
                tableData,
                columns: this.buildColumns(),
                pagination,
                emptyText: res.length ? '' : 'No data'
            });
        });
    }

    getLocalTime(time: any) {
        let formatted = this.formatDate(time);
        let date = moment(formatted).format('YYYY-MM-DD HH:mm:ss');
        let stillUtc = moment.utc(date).toDate();
        return moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    }

    formatDate(date: string) {
        if (date.indexOf('-') > -1) {
            let arr1 = date.split(' ');
            let arr2 = arr1[0].split('-');
            let arr3 = arr2.map((el, i) => {
                if (i === 0) {
                    return el;
                } else {
                    return ('0' + el).slice(-2);
                }
            });
            return arr3.join('-') + ' ' + arr1[1];
        }
        return date;
    }

    buildData(dataArray: any) {
        let columnData: any = [];
        dataArray.forEach((element: any) => {
            let row: any = {
                customer: element.customer ? element.customer.length ?
                    element.customer : element.customer.name : 'EYE GUIDE',
                username: element.username
            };
            if (this.listId === 'tests') {
                row.organization = element.organization;
                row.profile = element.firstname + ' ' + element.lastname;
                row.testtype = element.testtype;
                let formatted = this.formatDate(element.testdate);
                row.datetime = moment(formatted).format('YYYY-MM-DD HH:mm:ss');
                columnData.push(row);

            } else if (this.listId === 'logins') {
                row.datetime = this.getLocalTime(element.time);
                columnData.push(row);

            } else if (this.listId === 'syncs') {
                row.datetime = this.getLocalTime(element.time);
                row.status = element.type === 107 ? 'Completed' : 'Failed';
                columnData.push(row);

            } else if (this.listId === 'orgs') {
                let formatted = this.formatDate(element.createdat);
                row.datetime = moment(formatted).format('YYYY-MM-DD HH:mm:ss');
                row.datetime = this.getLocalTime(element.createdat);
                // let data: any = JSON.parse(element.data);
                
                // if (data.organizations !== undefined) {
                //     let orgs = data.organizations.map(org => {
                //         return {
                //             ...row,
                //             organization: org.name
                //         };
                //     });
                //     columnData.push(...orgs);
                // } else {
                //     row.organization = data.organization ? data.organization :
                //         data.customername ? data.customername : '';
                //     columnData.push(row);
                // }
                row.organization = element.organization;
                columnData.push(row);
            }
        });
        console.log('column data', columnData);
        return columnData;
    }

    buildColumns() {
        let columns: any = [];
        headers[this.listId].forEach((col, index) => {
            columns.push({
                title: titles[this.listId][index],
                dataIndex: col,
                sorter: (a: any, b: any) => a[col].localeCompare(b[col]),
                className: 'rows',
                render: (text: any, record: any) => (
                    <div
                        className="clipped"
                        style={{width: '140px'}}
                        title={text}
                    >
                        {text}
                    </div>
                ),
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            });
        });
        console.log('----columns----', columns);
        return columns;
    }
    
    filterActivityList = (filter) => {
        let tableData: any = [];
        tableData = dataHolder.filter((row: any) => {
            let matched = false;
            let comp = new Comparator();
            let filterObj: any = [];
            let compareObj: any = [];
            if (filter.customer.length) {
                filterObj.name = filter.customer;
                compareObj.name = row.customer;
            }
            if (filter.username.length) {
                filterObj.username = filter.username;
                compareObj.username = row.username;
            }
            if (filter.daterange[0].length) {
                filterObj.starttime = filter.daterange[0];
                filterObj.endtime = filter.daterange[1];
                compareObj.datetime = row.datetime.indexOf(' ') > -1 ?
                    row.datetime.split(' ')[0] : row.datetime;
            }
            if (filter.organization.length) {
                filterObj.organizationname = filter.organization;
                compareObj.organizationname = row.organization;
            }
            if (filter.profile.length) {
                filterObj.profile = filter.profile;
                compareObj.profile = row.profile;
            }
            matched = comp.compare(filterObj, compareObj);
            // console.log('comparator', matched);
            return matched;
        });
        let pagination = {...this.state.pagination};
        pagination.total = tableData.length;
        pagination.showTotal = (total: any) => {
            return 'Total ' + total + ' ' + this.title;
        };
        this.setState({
            pagination,
            tableData,
            emptyText: tableData.length ? '' : 'No data',
            filterObj: filter,
            filterModalVisible: false
        });
    }

    render() {
        let filterObj = this.state.filterObj;
        let holdFilter = this.state.holdFilter;
        return (
            <React.Fragment>
                <Card>
                    <div 
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline'
                        }}
                    >
                        <h3>{this.title}</h3>
                        <Button
                            type="primary"
                            onClick={() => history.back()}
                        >
                        {/* <Icon 
                            type="arrow-left" 
                            style={{ fontSize: 19, cursor: 'pointer' }}
                            onClick={() => history.back()}
                        />&nbsp;&nbsp; */}
                            Back
                        </Button>
                    </div>
                </Card>
                <Card className="TestFilter" style={{margin: '24px 24px'}}>
                    <Icon 
                        type="filter" 
                        onClick={() => this.toggleFilterModal()}
                        style={{fontSize: 19, float: 'right', cursor: 'pointer'}}
                    />
                    <span hidden={!this.noFiltersApplied()}>
                        {strings.lsNoFilterTxt}
                    </span>
                    <div hidden={this.noFiltersApplied()}>
                        <Button 
                            className="clearFilter" 
                            onClick={this.clearFilters}
                        >
                            Clear Filters
                        </Button>
                        {
                            Object.keys(filterObj).map((key, index) => {
                                let value1 = filterObj[key];
                                let value2 = '';
                                if (key === 'daterange') {
                                    value1 = filterObj[key][0];
                                    value2 = filterObj[key][1];
                                }
                                return (
                                    <Row key={key} className="filterRow" hidden={value1 === ''}>

                                        <Col span={8}>{filters[index]} :</Col>
                                        <Col span={12}>
                                            {!value2.length ? value1 : value1 + ' ... ' + value2}
                                        </Col>
                                    </Row>
                                );
                            })
                        }
                    </div>
                </Card>
                <Card style={{margin: '24px 24px'}}>
                    <Table 
                        style={{overflowX: 'auto'}}
                        className="CustomerList"
                        columns={this.state.columns} 
                        dataSource={this.state.tableData} 
                        pagination={this.state.pagination}
                        rowKey={(record: any) => record.id}
                        loading={this.state.loading}
                        rowClassName={(record, index) => 'rows'}
                        locale={{ emptyText: this.state.emptyText }} 
                    />
                </Card>
                <Modal 
                    className="modal"
                    title={'Filter ' + this.title}
                    visible={this.state.filterModalVisible}
                    okText={strings.lsFilterTxt}
                    onOk={() => this.filterActivityList(holdFilter)}
                    onCancel={() => this.toggleFilterModal()}
                    width={750}
                    bodyStyle={{padding: 0}}
                    maskClosable={false}
                    closable={false}
                    destroyOnClose={true}
                ><br />
                <div className="TestFilter">
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>Customer :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                style={{width: 200}}
                                ref={el => this.inputEl = el}
                                value={holdFilter.customer} 
                                onChange={(e) => this.handleInputChange(e, 'customer')}
                            />
                        </Col>
                    </Row>
                    {(this.listId === 'logins' || this.listId === 'syncs')
                        &&
                        <Row className="row">
                            <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                            <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                                <div className="label">
                                    <span>Username :</span>
                                </div>
                            </Col>
                            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                <Input 
                                    style={{width: 200}}
                                    value={holdFilter.username} 
                                    onChange={(e) => this.handleInputChange(e, 'username')}
                                    autoFocus={true}
                                />
                            </Col>
                        </Row>
                    }
                    {(this.listId === 'tests' || this.listId === 'orgs')
                        &&
                        <Row className="row">
                            <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                            <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                                <div className="label">
                                    <span>Organization :</span>
                                </div>
                            </Col>
                            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                <Input 
                                    style={{width: 200}}
                                    value={holdFilter.organization} 
                                    onChange={(e) => this.handleInputChange(e, 'organization')}
                                />
                            </Col>
                        </Row>
                    }
                    {this.listId === 'tests' && 
                        <Row className="row">
                            <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                            <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                                <div className="label">
                                    <span>Profile Name :</span>
                                </div>
                            </Col>
                            <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                                <Input 
                                    style={{width: 200}}
                                    value={holdFilter.profile} 
                                    onChange={(e) => this.handleInputChange(e, 'profile')}
                                />
                            </Col>
                        </Row>
                    }
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>Date Range :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <RangePicker 
                                onChange={this.handleDateRange}
                                format="YYYY-MM-DD"
                                value={holdFilter.daterange[0] !== '' ?
                                    [moment(holdFilter.daterange[0]), moment(holdFilter.daterange[1])] 
                                    : []}
                                disabledDate={date => {
                                    let iso = date.toISOString().split('T')[0];
                                    return iso.localeCompare(dateRange[0]) === -1
                                        || dateRange[1].localeCompare(iso) === -1;
                                }}
                            />
                        </Col>
                    </Row>
                </div><br /> 
                </Modal>
            </React.Fragment>
        );
    }

    clearFilters = () => {
        let holdFilter = {
            customer: '',
            organization: '',
            username: '',
            profile: '',
            daterange: ['', '']
        };
        this.setState(
            {holdFilter},
            () => this.filterActivityList(holdFilter)
        );
    }

    noFiltersApplied = () => {
        let filterObj = this.state.filterObj;
        let counter = 0;
        Object.keys(filterObj).forEach(key => {
            if (filterObj[key] === '') {
                counter++;
            }
        });
        if (filterObj.daterange[0] === '') {
            counter++;
        }
        console.log('no filters', counter);
        return Object.keys(filterObj).length === counter;
    }

    handleInputChange = (e, key) => {
        let holdFilter = {...this.state.holdFilter};
        holdFilter[key] = e.target.value;
        this.setState({ holdFilter });
    }

    handleDateRange = (date: any, dateString: any) => {
        console.log('date range', dateString);
        let holdFilter = {...this.state.holdFilter};
        holdFilter.daterange = dateString;
        this.setState({ holdFilter });
    }

    toggleFilterModal = () => {
        this.setState(
            {filterModalVisible: !this.state.filterModalVisible},
            () => setTimeout(() => this.inputEl.focus(), 100)
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ActivityTable.tsx